var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGitHub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25C0 38.8071 11.1929 50 25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25Z",
    fill: "#231E1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9618 12.7998C18.081 12.7998 12.5 18.3808 12.5 25.2616C12.5 30.7662 16.0933 35.4298 20.9862 37.1117C21.5979 37.1882 21.8272 36.8059 21.8272 36.5001C21.8272 36.1943 21.8272 35.4298 21.8272 34.3594C18.3868 35.124 17.6223 32.6775 17.6223 32.6775C17.0872 31.2249 16.2462 30.8426 16.2462 30.8426C15.0994 30.0781 16.3226 30.0781 16.3226 30.0781C17.5459 30.1545 18.2339 31.3778 18.2339 31.3778C19.3807 33.2891 21.1391 32.7539 21.8272 32.4481C21.9037 31.6071 22.2859 31.072 22.5917 30.7662C19.8394 30.4604 16.9343 29.39 16.9343 24.5735C16.9343 23.1974 17.393 22.127 18.2339 21.2096C18.1575 20.9802 17.6988 19.6805 18.3868 17.9986C18.3868 17.9986 19.4572 17.6928 21.8272 19.2983C22.8211 18.9925 23.8914 18.916 24.9618 18.916C26.0321 18.916 27.1024 19.0689 28.0963 19.2983C30.4664 17.6928 31.5367 17.9986 31.5367 17.9986C32.2248 19.6805 31.7661 20.9802 31.6896 21.286C32.4541 22.127 32.9893 23.2738 32.9893 24.65C32.9893 29.4665 30.0841 30.4604 27.3318 30.7662C27.7905 31.1484 28.1728 31.913 28.1728 33.0597C28.1728 34.7417 28.1728 36.0414 28.1728 36.5001C28.1728 36.8059 28.4021 37.1882 29.0138 37.1117C33.9832 35.4298 37.5 30.7662 37.5 25.2616C37.4235 18.3808 31.8425 12.7998 24.9618 12.7998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitHub);
export default __webpack_public_path__ + "static/media/GitHub.504b66aacc2e83e5b05d2dcfed302c14.svg";
export { ForwardRef as ReactComponent };